import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="p-6 rounded-lg bg-card border border-border">
      <div className="flex gap-1 mb-4">
        {[...Array(5)]?.map((_, i) => (
          <Icon
            key={i}
            name="Star"
            size={16}
            color="var(--color-warning)"
            className="fill-current"
          />
        ))}
      </div>
      <p className="text-sm text-foreground mb-6 leading-relaxed">
        "{testimonial?.quote}"
      </p>
      <div className="flex items-center gap-3">
        <Image
          src={testimonial?.avatar}
          alt={testimonial?.avatarAlt}
          className="w-12 h-12 rounded-full object-cover"
        />
        <div>
          <div className="font-semibold text-foreground text-sm">
            {testimonial?.name}
          </div>
          <div className="text-xs text-muted-foreground">
            {testimonial?.role}
          </div>
          <div className="text-xs text-muted-foreground">
            {testimonial?.company}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;